import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function CanonicalManager() {
  const location = useLocation();

  useEffect(() => {
    const canonicalUrl = `https://langfinity.ai${location.pathname}`;
    let link = document.querySelector("link[rel='canonical']") as HTMLLinkElement;
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = canonicalUrl;
  }, [location]);

  return null;
}